import { createSelector, type OutputSelector } from 'reselect';
import { createHook } from '../index.tsx';
import type { State } from '../types.tsx';

const getStartWithTemplateSpotlight = (state: State) => state.startWithTemplateSpotlight;

export const getStartWithTemplateSpotlightDismissed: OutputSelector<
	State,
	boolean | undefined,
	(res: { spotlightDismissed?: boolean }) => boolean | undefined
> = createSelector(
	getStartWithTemplateSpotlight,
	(startWithTemplateSpotlight) => startWithTemplateSpotlight.spotlightDismissed,
);

export const useStartWithTemplateSpotlightDismissed: () => boolean | undefined = createHook(
	getStartWithTemplateSpotlightDismissed,
);
